import { render, staticRenderFns } from "./savedAddress.vue?vue&type=template&id=92807758&scoped=true"
import script from "./savedAddress.vue?vue&type=script&lang=js"
export * from "./savedAddress.vue?vue&type=script&lang=js"
import style0 from "./savedAddress.vue?vue&type=style&index=0&id=92807758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92807758",
  null
  
)

export default component.exports